// extracted by mini-css-extract-plugin
module.exports = {"logo":"RegisterInvestor_logo__29FF5","logo_container":"RegisterInvestor_logo_container__3WDrr"};